var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxCheckedS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11111 1H1V11H2.11111H9.88889H11V1H9.88889H2.11111ZM2.11111 2.11111H9.88889V9.88889H2.11111V2.11111ZM4.33333 6H3.22222V7.11111H4.33333L4.33333 8.22222H5.44444V7.11111H6.55556V6H7.66667V4.88889H8.77778V3.77778H7.66667V4.88889H6.55556L6.55556 6H5.44444V7.11111H4.33333V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxCheckedS);
export default __webpack_public_path__ + "static/media/check-box-checked-s.94f555dd27a594cc4e051be82e6c3ed5.svg";
export { ForwardRef as ReactComponent };